// extracted by mini-css-extract-plugin
export default {"nothingFound":"styles_nothingFound__GkRdR","icon":"styles_icon__ow+HM","redirectLink":"styles_redirectLink__VtJrM"};